// Gerenciador de Tema: Claro / Escuro / Automático (Sistema)

export type ThemePreference = 'system' | 'dark' | 'light';

const THEME_STORAGE_KEY = 'zac_theme_preference';

export function getStoredTheme(): ThemePreference {
  const saved = localStorage.getItem(THEME_STORAGE_KEY);
  if (saved === 'dark' || saved === 'light' || saved === 'system') {
    return saved;
  }
  return 'system';
}

export function applyTheme(preference: ThemePreference) {
  localStorage.setItem(THEME_STORAGE_KEY, preference);

  const isDark =
    preference === 'dark' ||
    (preference === 'system' && window.matchMedia('(prefers-color-scheme: dark)').matches);

  if (isDark) {
    document.documentElement.classList.add('dark');
  } else {
    document.documentElement.classList.remove('dark');
  }
}

export function initThemeListener(onThemeChange?: () => void) {
  const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');

  const handler = () => {
    if (getStoredTheme() === 'system') {
      applyTheme('system');
      if (onThemeChange) onThemeChange();
    }
  };

  mediaQuery.addEventListener('change', handler);
  return () => mediaQuery.removeEventListener('change', handler);
}
